import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import HeadingAndSupportingText, { HeadingAndSupportingTextProps } from './HeadingAndSupportingText';
import { DirectionType, JustifyType, AlignType } from 'src/app/atoms/Layout/Stack/Stack.styles';

export interface HeadingAndSupportingTextWithActionsProps extends HeadingAndSupportingTextProps {
  actions: React.ReactNode;
  direction?: DirectionType;
  justify?: JustifyType;
  align?: AlignType;
}

const HeadingAndSupportingTextWithActions = ({
  actions,
  direction = 'row',
  justify = 'space-between',
  align = 'flex-start',
  ...rest
}: HeadingAndSupportingTextWithActionsProps): JSX.Element => (
  <Stack
    direction={direction}
    justify={justify}
    align={align}
    dataCy='heading-and-supporting-text-with-actions-container'
  >
    <HeadingAndSupportingText {...rest} />
    {actions}
  </Stack>
);

export default HeadingAndSupportingTextWithActions;
